import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import VSpace from "../common/VSpace"
import { faHouse } from "@fortawesome/pro-duotone-svg-icons"

const SelectPropertyView = () => {
  return <div className="overlay">
    <VSpace size="large">
      <FontAwesomeIcon icon={faHouse} size="3x" />
      <span>SELECT A PROPERTY</span>
    </VSpace>
  </div>
}

export default SelectPropertyView